import {useCallback, useMemo, useState} from 'react';

import {LocalStorage} from '@pb/kit-util-client-storage';

const DRAFT_PREFIX = 'cr_comment_draft:';
const HTML_TAGS_REGEX = /<[^>]*>/g;

const getComment = (key: string | null) => (key ? LocalStorage.get(key) || '' : '');
const getCommentDraftKey =
    (changeRequestId: number) => `${DRAFT_PREFIX}${changeRequestId}`;

export const useCurrentComment = (
    changeRequestId: number | null,
) => {
    const draftKey = useMemo(() =>
        changeRequestId ? getCommentDraftKey(changeRequestId) : null, [changeRequestId]);
    const [currentComment, setCurrentComment] = useState<string>(() => getComment(draftKey));

    const updateCurrentComment = useCallback((comment: string, hasDraft?: boolean) => {
        setCurrentComment(comment);

        if (draftKey && hasDraft) {
            const isTextEmpty = !comment.replace(HTML_TAGS_REGEX, '').trim();

            if (isTextEmpty) {
                LocalStorage.remove(draftKey);
                return;
            }

            LocalStorage.set(draftKey, comment);
        }
    }, [draftKey]);

    const clearCommentDraft = useCallback(() => {
        if (draftKey) {
            LocalStorage.remove(draftKey);
            setCurrentComment('');
        }
    }, [draftKey]);

    return {currentComment, updateCurrentComment, clearCommentDraft};
};
